import React, { useState } from "react";
import { Query } from "react-apollo";
import _ from "lodash";
import gql from "graphql-tag";
import StatsDataTable from "./stats-datatable";

const QUERY = gql`
  query statsByTaskId($id: ID, $skip: Int!, $limit: Int!) {
    statsByTaskId(id: $id, skip: $skip, limit: $limit) {
      data {
        id
        resource {
          name
        }
        indicator {
          name
        }
        years {
          lower
          upper
        }
        value
        probability
        typing
        description
      }
      total
      rows
    }
  }
`;

const LoadedData = ({ id, status, openPanel }) => {
  const [filters, changeFilters] = useState({
    limit: 50,
    skip: 0,
    page: 0,
  });
  if (status !== "COMPLETE") {
    return null;
  }
  return (
    <Query query={QUERY} variables={{ id, ...filters }} fetchPolicy="cache-and-network">
      {({ data, loading, error }) => {
        if (loading || error) {
          return null;
        }

        //const { statsByTaskId } = data;
        const items = _.get(data, "statsByTaskId.data");
        const total = _.get(data, "statsByTaskId.total");

        return (
          <StatsDataTable
            data={items}
            filters={filters}
            total={total}
            onChange={(filters) => changeFilters(filters)}
            openPanel={openPanel}
          />
        );
      }}
    </Query>
  );
};

export default LoadedData;



// WEBPACK FOOTER //
// ./src/components/admin/carto/stats/loaded-data.js